if (!customElements.get('wim-subscription-selector')) {
  class WimSubscriptionSelector extends HTMLElement {
    connectedCallback() {
      this.sellingPlanInput = this.querySelector('[data-wim-selling-plan-input]');
      this.variantPanels = this.querySelectorAll('[data-wim-variant-id]');
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onOptionChange = this.onOptionChange.bind(this);
      this.onVariantInputChange = this.onVariantInputChange.bind(this);

      this.addEventListener('change', this.onOptionChange);

      if (theme?.pubsub?.subscribe) {
        this.unsubscribeVariantChange = theme.pubsub.subscribe(
          theme.pubsub.PUB_SUB_EVENTS.variantChange,
          this.onVariantChange
        );
      }

      this.bindVariantInput();
      this.syncFromCheckedOption();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onOptionChange);
      this.unsubscribeVariantChange?.();
      this.variantIdInput?.removeEventListener('change', this.onVariantInputChange);
    }

    get sectionId() {
      return this.dataset.sectionId;
    }

    get productId() {
      return this.dataset.productId;
    }

    bindVariantInput() {
      const form = document.getElementById(`ProductForm-${this.sectionId}-${this.productId}`);
      this.variantIdInput = form?.querySelector('input[name="id"]');
      this.variantIdInput?.addEventListener('change', this.onVariantInputChange);
    }

    onVariantInputChange(event) {
      const variantId = event.target?.value;
      if (!variantId) return;
      this.showVariantPanel(variantId);
      this.syncFromCheckedOption();
    }

    onVariantChange(event) {
      if (event?.data?.sectionId && event.data.sectionId !== this.sectionId) return;
      if (event?.data?.productId && String(event.data.productId) !== String(this.productId)) return;

      const variantId = event?.data?.variant?.id;
      if (variantId) {
        this.showVariantPanel(variantId);
      }
      this.syncFromCheckedOption();
    }

    showVariantPanel(variantId) {
      this.variantPanels.forEach((panel) => {
        const isMatch = String(panel.dataset.wimVariantId) === String(variantId);
        panel.classList.toggle('wim-subscription__variant--hidden', !isMatch);
      });
    }

    onOptionChange(event) {
      const target = event.target;
      if (!target?.matches?.('[data-wim-purchase-option]')) return;
      this.updateSellingPlanInput(target.dataset.sellingPlanId || '');
      this.updateBuyButtonPrice(target.dataset.price);
    }

    syncFromCheckedOption() {
      const activePanel = this.querySelector('.wim-subscription__variant:not(.wim-subscription__variant--hidden)');
      const checked = activePanel?.querySelector('[data-wim-purchase-option]:checked');
      this.updateSellingPlanInput(checked?.dataset.sellingPlanId || '');
      this.updateBuyButtonPrice(checked?.dataset.price);
      // The theme re-renders the buy button after a variant change, so apply the price again once it has.
      setTimeout(() => this.updateBuyButtonPrice(checked?.dataset.price), 0);
    }

    // Shows the price of the selected purchase option (subscription or one-time) in the add-to-cart button.
    updateBuyButtonPrice(price) {
      const amount = parseInt(price, 10);
      if (Number.isNaN(amount)) return;
      const buyPrice = document.querySelector(`#BuyButtonPrice-${this.sectionId}-${this.productId} product-buy-price`);
      if (!buyPrice) return;
      buyPrice.setAttribute('data-price', amount);
      // product-buy-price is defined in theme.js, which can load after this script.
      customElements.whenDefined('product-buy-price').then(() => {
        if (typeof buyPrice.updatePrice === 'function') {
          buyPrice.updatePrice(amount);
        }
      });
    }

    updateSellingPlanInput(sellingPlanId) {
      if (!this.sellingPlanInput) return;
      this.sellingPlanInput.value = sellingPlanId || '';
    }
  }

  customElements.define('wim-subscription-selector', WimSubscriptionSelector);
}
